import React from "react"
import { GeoJSON, useMap } from "react-leaflet"
import { ensurePane } from "@/utils/mapUx"
import { useGisSuppressed } from "@/features/gis/GisInteractivityContext.jsx"

// Dedicated pane so GIS vectors stack above benchmaps weather layers
// (pane 450), but below routes (600+).
export const GIS_PANE = "gisPane"
export const GIS_PANE_Z = 480

/**
 * A thin wrapper around React-Leaflet’s GeoJSON to render feature collections.
 *
 * @param {Object[]} data         GeoJSON Feature[] array
 * @param {Object|Function} style CSS style object or function(feature):style
 * @param {Function} onEachFeature (feature, layer) => void
 * @param {*} rest                any other props for <GeoJSON>
 */
export default function GeoJsonLayer({ data, style, onEachFeature, interactive = true, ...rest }) {
  const map = useMap()
  const suppressed = useGisSuppressed()
  if (!data) return null
  ensurePane(map, GIS_PANE, GIS_PANE_Z)
  // Leaflet reads `interactive` only at layer creation, so remount on change.
  const effectiveStyle = suppressed
    ? (feature) =>
        typeof style === "function"
          ? { ...style(feature), interactive: false }
          : { ...style, interactive: false }
    : style
  return (
    <GeoJSON
      key={suppressed ? "gis-suppressed" : "gis-interactive"}
      pane={GIS_PANE}
      data={data}
      style={effectiveStyle}
      onEachFeature={onEachFeature}
      interactive={interactive && !suppressed}
      {...rest}
    />
  )
}
